import AccountIssuesPage from "./AccountIssuesPage";

export default AccountIssuesPage;
